// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KFxp","label":"styles_label__2WnWM"};